import { IToastConfig } from 'src/common/primitives/Toast';

export function generateEditSuccessToast(memberName: string): IToastConfig {
  return {
    type: 'success',
    title: `${memberName} updated successfully`,
  };
}
